export interface ShiftSaveModel {
    readonly name: string;
    /** Lab-local time of day, `HH:mm` or `HH:mm:ss`. */
    readonly startTime: string;
    readonly endTime: string;
    readonly isActive: boolean;
}
